import React from 'react';
import GoogleMapReact from 'google-map-react';
import Mapa from './mapa';
import Select from 'react-select';
import Firebase from 'firebase';
import DatePicker from 'react-datepicker';
import moment from 'moment';


export default class main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auditor: "",
            fecha: new Date(),
            formatFecha: this.DateToFormattedString(new Date())
        }
    }

    componentDidMount() {
        var userRef = Firebase.database().ref("users").orderByChild("client_id").equalTo("cafehaiti");
        var formRef = Firebase.database().ref("forms").orderByChild("client_id").equalTo("cafehaiti");
        userRef.once("value").then(resp => {
            var users = new Array();
            resp.forEach(usuario => {
                users.push({
                    value: usuario.val().rut,
                    label: usuario.val().name
                })
            });
            this.setState({ auditores: users })
        });
        formRef.once("value").then(resp => {
            var forms = new Array();
            resp.forEach(form => {
                forms.push({
                    value: form.key,
                    label: form.val().name
                })
            });
            this.setState({ formularios: forms })
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.form !== this.state.form) {
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextState.form);
            dataRef.once('value').then(resp => {
                this.setState({ lastVersion: Object.keys(resp.val())[Object.keys(resp.val()).length - 1] });
            })
        }
    }

    DateToFormattedString(date) {
        var d = new Date(date);
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return yyyy + "/" + (mm[1] ? mm : "0" + mm[0]) + "/" + (dd[1] ? dd : "0" + dd[0]) + " " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    setReg(reg) {
        this.setState({ reg: reg })
    }

    render() {
        return (
            <div className="form-group row">
                <div className="col-md-6">
                    <div className="form-group row">
                        <div className="col-md-4">
                            <Select
                                name="form-field-name"
                                className="Select Select--single is-searchable has-value"
                                value={this.state.form}
                                options={this.state.formularios}
                                onChange={(e) => { this.setState({ form: e.value }) }}
                            />
                        </div>
                        <div className="col-md-4">
                            <Select
                                name="form-field-name"
                                className="Select Select--single is-searchable has-value"
                                value={this.state.auditor}
                                options={this.state.auditores}
                                onChange={(e) => { this.setState({ auditor: e.value }) }}
                            />
                        </div>
                        <div className="col-md-4">
                            <DatePicker
                                placeholderText={this.state.formatFecha}
                                className="form-control"
                                onChange={(e) => { this.setState({ fecha: e._d, formatFecha: this.DateToFormattedString(e._d) }) }}
                            />
                        </div>
                    </div>
                    <Mapa auditor={this.state.auditor} form={this.state.form} lastVersion={this.state.lastVersion} fecha={this.state.fecha} regSelected={(reg) => this.setState({ reg: reg })} />
                </div>
                <div className="col-md-6">
                    <div className="form-group row" style={{ marginTop: "50px" }}>
                        <div className="col-md-6" style={{ border: "1px solid #ccc", padding: "10px", width: "50%" }} >
                            
                        </div>
                        <div className="col-md-6" >
                            <div className="card">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">Fecha toma del registro: <b style={{ position: "absolute", right: "10%" }}>{this.state.reg ? this.DateToFormattedString(this.state.reg.global.date.device) : "sin información"}</b></li>
                                    <li className="list-group-item">Cadena: <b style={{ position: "absolute", right: "10%" }}>{this.state.reg ? this.state.reg.results.cadena : "sin información"}</b> </li>
                                    <li className="list-group-item">Codigo local: <b style={{ position: "absolute", right: "10%" }}>{this.state.reg ? this.state.reg.results.local : "sin información"}</b> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/cafe-haiti/mapa/main.js